import React, { useState, useRef } from 'react';
import './InstituteDashboard.css';

import {
  Card,
  ListGroup,
  Container,
  Row,
  Col,
  Button,
  Form,
  Table,
  Alert,
  Modal,
  Badge,
  InputGroup
} from 'react-bootstrap';


// Utility to get initials for avatar
function getInitials(name) {
  if (!name) return '';
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
// Utility to pick a color for avatar
function pickAvatarColor(initials) {
  const palette = [
    "#6C63FF", "#43D9AD", "#FF7F50", "#EE4266", "#1B9AAA", "#FFD166", "#4ECDC4"
  ];
  if (!initials) return palette[0];
  let sum = 0;
  for (let i = 0; i < initials.length; i++) sum += initials.charCodeAt(i);
  return palette[sum % palette.length];
}

function InstituteDashboard({ institute, onProfileUpdate, onLogout, onSwitchRole }) {
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState(null);
const [loadingProfile, setLoadingProfile] = useState(true);
const [profileError, setProfileError] = useState('');

  const [message, setMessage] = useState('');
  const [departmentName, setDepartmentName] = useState('');
  const [courseName, setCourseName] = useState('');
  const [coursesForDept, setCoursesForDept] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [search, setSearch] = useState('');
  
  // --- Application Messaging (per application) ---
const [showAppMsgModal, setShowAppMsgModal] = useState(false);
const [activeAppMsg, setActiveAppMsg] = useState(null); // Holds the application object in focus
const [appMsgThread, setAppMsgThread] = useState([]);
const [appMsgLoading, setAppMsgLoading] = useState(false);
const [appMsgText, setAppMsgText] = useState('');
const [appMsgError, setAppMsgError] = useState('');


  const [editingDeptIdx, setEditingDeptIdx] = useState(null);
  const [editDeptName, setEditDeptName] = useState('');
  const [editDeptCourses, setEditDeptCourses] = useState([]);
  const [editCourseName, setEditCourseName] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [profileStudent, setProfileStudent] = useState(null);
  const [applicationFormToPreview, setApplicationFormToPreview] = useState(null);
  
  // for institute logo, photo and fee structure.
const [logoFile, setLogoFile] = useState(null);
const [coverFile, setCoverFile] = useState(null);
const [feeFile, setFeeFile] = useState(null);

const [uploading, setUploading] = useState(false);
const [uploadError, setUploadError] = useState('');


  // Password change
  const [showPwModal, setShowPwModal] = useState(false);
  const [pwForm, setPwForm] = useState({ current: '', new: '', confirm: '' });
  const [pwError, setPwError] = useState('');
  const [pwSuccess, setPwSuccess] = useState('');
  

const [applications, setApplications] = useState([]);
const [loadingApplications, setLoadingApplications] = useState(true);
const [applicationsError, setApplicationsError] = useState('');

const [adminMessages, setAdminMessages] = useState([]);
const [loadingAdminMsgs, setLoadingAdminMsgs] = useState(false);
const [adminMsgError, setAdminMsgError] = useState('');


//Helper for Student doc Preview
const [hoveredDocIndex, setHoveredDocIndex] = useState(null);

const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
const API_BASE = isDev ? "http://localhost:5000" : "";

function getDocDownloadUrl(doc) {
  return doc?.url ? `${API_BASE}${doc.url}` : doc.data;
}




  // Admin Messaging
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [adminMsgText, setAdminMsgText] = useState('');
  const [forceAdminUpdate, setForceAdminUpdate] = useState(false);




const hasUnreadAdmin = Array.isArray(adminMessages) && adminMessages.some(m => m.from === 'admin' && !m.read);

const [adminMsgSendError, setAdminMsgSendError] = useState('');
const [adminMsgSendSuccess, setAdminMsgSendSuccess] = useState('');


//Defensive Code Block

const departments = Array.isArray(form?.departments) ? form.departments : [];

const adminMsgs = Array.isArray(adminMessages) ? adminMessages : [];



const profileDocs = Array.isArray(profileStudent?.documents) ? profileStudent.documents : [];
const profileApps = Array.isArray(profileStudent?.applications) ? profileStudent.applications : [];



// --- Queries (Student > Institute) ---
const [instQueries, setInstQueries] = useState([]);
const [showQueriesModal, setShowQueriesModal] = useState(false);
const [queriesLoading, setQueriesLoading] = useState(false);
const [queriesError, setQueriesError] = useState('');
const [selectedQuery, setSelectedQuery] = useState(null);
const [newQueryCount, setNewQueryCount] = useState(0); // For "New" badge
const [readQueryIds, setReadQueryIds] = useState([]); // For tracking which queries have been read
const hasMarkedQueriesRead = useRef(false);
const [queryDateFilter, setQueryDateFilter] = useState(""); // for queries date filter


const instituteEmail = institute?.email;

const [sessionFilter, setSessionFilter] = useState('');


const [searchInput, setSearchInput] = useState('');
const [page, setPage] = useState(1);
const [limit] = useState(100);
const [hasMore, setHasMore] = useState(false);
const [loadingMore, setLoadingMore] = useState(false);
// Input (draft) values for date/session, applied only on "Apply"
const [fromDateInput, setFromDateInput] = useState(fromDate);
const [toDateInput, setToDateInput] = useState(toDate);
const [sessionFilterInput, setSessionFilterInput] = useState(sessionFilter);





React.useEffect(() => {
  if (instituteEmail) {
    setLoadingProfile(true);
    setProfileError('');
    const token = localStorage.getItem('authToken');
    fetch(`/api/institute/${instituteEmail}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        setForm(data);
        setLoadingProfile(false);
      })
      .catch(() => {
        setProfileError("Could not load institute profile.");
        setLoadingProfile(false);
      });
  }
}, [instituteEmail]);

//query useEffect
React.useEffect(() => {
  if (!showQueriesModal) return;
  setQueriesLoading(true);
  setQueriesError('');
  const token = localStorage.getItem('authToken');
  fetch('/api/institute/queries', {
    headers: { 'Authorization': `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => {
      setInstQueries(data.queries || []);
      // Find queries not in readQueryIds and count as "new"
      const unread = (data.queries || []).filter(q => !readQueryIds.includes(q._id));
      setNewQueryCount(unread.length);
      setQueriesLoading(false);
    })
    .catch(() => {
      setQueriesError('Could not load queries.');
      setQueriesLoading(false);
    });
}, [showQueriesModal, readQueryIds]);


React.useEffect(() => {
  if (!showQueriesModal) {
    hasMarkedQueriesRead.current = false;
  }
}, [showQueriesModal]);







React.useEffect(() => {
  if (form?.email) {
    const token = localStorage.getItem('authToken');
    const params = new URLSearchParams();

    params.set('page', String(page));           // <-- you'll need: const [page, setPage] = useState(1);
    params.set('limit', '100');                 // how many per load
    if (search) params.set('search', search);   // <-- you'll need: const [search, setSearch] = useState('');
    if (fromDate) params.set('from', fromDate); // <-- you'll need: const [fromDate, setFromDate] = useState('');
    if (toDate) params.set('to', toDate);       // <-- you'll need: const [toDate, setToDate] = useState('');
    if (sessionFilter) params.set('session', sessionFilter); // <-- you'll need: const [sessionFilter, setSessionFilter] = useState('');

    setLoadingApplications(page === 1); // show main spinner only for first page load
    setLoadingMore(page > 1);           // optional: show "Loading..." on Load more
    setApplicationsError('');

    fetch(`/api/institute/applications/${form.email}?${params.toString()}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        const list = Array.isArray(data.applications) ? data.applications : [];
        if (page === 1) {
          setApplications(list); // replace on first page
        } else {
          setApplications(prev => [...prev, ...list]); // append on later pages
        }
        setHasMore(Boolean(data.hasMore)); // <-- you'll need: const [hasMore, setHasMore] = useState(false);
        setLoadingApplications(false);
        setLoadingMore(false);
      })
      .catch(() => {
        if (page === 1) setApplications([]);
        setApplicationsError('Could not load applications.');
        setLoadingApplications(false);
        setLoadingMore(false);
      });
  }
}, [form?.email, page, search, fromDate, toDate, sessionFilter, forceUpdate]);





React.useEffect(() => {
  if (form?.email) {
    const token = localStorage.getItem('authToken');
    fetch(`/api/messages/admin-institute/${form.email}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => setAdminMessages(Array.isArray(data.messages) ? data.messages : []))
      .catch(() => setAdminMessages([]));
  }
}, [form?.email]);



if (loadingProfile) return <div>Loading profile...</div>;
if (profileError) return <div style={{ color: 'red' }}>{profileError}</div>;
if (!form) return null;

  

  
  const handleDownloadApplicationForm = async (student, course) => {
  if (!student || !student.email) {
    alert("No student selected!");
    return;
  }

  const studentEmail = student.email || student.studentEmail || (student.student && student.student.email);
if (!studentEmail) {
  alert("Cannot find student email for this application.");
  return;
}
fetch(`/api/institute/student-application-form/${studentEmail}`, {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
  }
})

    .then(res => {
      if (!res.ok) throw new Error("Application form not found");
      return res.json();
    })
    .then(formData => {
      // Find the application to this institute
      const application = applications.find(
  app => app.studentEmail === studentEmail && app.course === course
);
const appStatus = application?.status || "pending";


      // Copy form data so you don't change the real one
      let formDataToDownload = { ...formData };

      // Mask sensitive fields if not approved
      if (appStatus !== "approved") {
        formDataToDownload = {
          ...formDataToDownload,
          email: "********",
          cell: "********",
          guardianCell: "********"
        };
      }

      setApplicationFormToPreview(formDataToDownload);

      // Give React time to render the preview
      setTimeout(async () => {
        const appFormDiv = document.getElementById("application-form-preview");
        if (!appFormDiv) {
          alert("Form preview area not found.");
          return;
        }
        appFormDiv.style.display = "block"; // Make visible for screenshot

        // Dynamically import jsPDF and html2canvas
        const [{ default: jsPDF }, { default: html2canvas }] = await Promise.all([
          import("jspdf"),
          import("html2canvas"),
        ]);

        await html2canvas(appFormDiv, { scale: 2 }).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");

          // --- Force A4 PDF size and fit image ---
          const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
          });

          const pageWidth = 210; // A4 width in mm
          const pageHeight = 297; // A4 height in mm
          const imgProps = pdf.getImageProperties(imgData);

          // Calculate dimensions: fit to width, keep aspect ratio
          let imgWidth = pageWidth;
          let imgHeight = (imgProps.height * imgWidth) / imgProps.width;

          // If image is too tall, fit to height instead
          if (imgHeight > pageHeight) {
            imgHeight = pageHeight;
            imgWidth = (imgProps.width * imgHeight) / imgProps.height;
          }

          pdf.addImage(
            imgData,
            "PNG",
            (pageWidth - imgWidth) / 2, // center horizontally
            0,                          // top
            imgWidth,
            imgHeight
          );
          pdf.save(`${student.name || "student"}_ApplicationForm.pdf`);
        });

        appFormDiv.style.display = "none"; // Hide after screenshot
      }, 300); // Wait 0.3 seconds for UI to render
    })
    .catch(() => {
      alert("This student has not filled the application form.");
    });
};


// Add the "Open Messages Modal" function:

// Open messaging modal for a specific application
function handleOpenAppMsgModal(app, studentEmail) {
  setActiveAppMsg({ ...app, studentEmail });
  setShowAppMsgModal(true);
  setAppMsgLoading(true);
  setAppMsgError('');
  setAppMsgText('');

  const token = localStorage.getItem('authToken');
  // Fetch the message thread for this application
    fetch(`/api/applications/messages?studentEmail=${encodeURIComponent(studentEmail)}&instituteEmail=${encodeURIComponent(form.email)}&course=${encodeURIComponent(app.course)}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
    .then(res => res.json())
    .then(data => {
      setAppMsgThread(data.messages || []);
      setAppMsgLoading(false);

      // Mark all student messages as read for this application
      fetch('/api/applications/messages/mark-read', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          studentEmail,
          instituteEmail: form.email,
          course: app.course
        })
      }).then(() => {
        // Reload applicants so application list is refreshed (badges update)
        fetch(`/api/institute/applications/${form.email}`, {
  headers: {
    'Authorization': `Bearer ${token}`
  }
})
  .then(res => res.json())
  .then(data => setApplications(data.applications || []));

      });
    })

    .catch(() => {
      setAppMsgError('Could not load messages');
      setAppMsgLoading(false);
    });
}


//Add the "Send Message" function:



// Send a new message for this application
function handleSendAppMsg() {
  if (!activeAppMsg || !appMsgText.trim()) return;
  setAppMsgLoading(true);
  setAppMsgError('');
  const token = localStorage.getItem('authToken');
  fetch('/api/applications/message', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      studentEmail: activeAppMsg.studentEmail,
      instituteEmail: form.email,
      course: activeAppMsg.course,
      text: appMsgText.trim()
    })
  })
    .then(res => res.json())
    .then(data => {
      setAppMsgThread(data.messages || []);
      setAppMsgText('');
      setAppMsgLoading(false);
    })
    .catch(() => {
      setAppMsgError('Could not send message');
      setAppMsgLoading(false);
    });
}


// Function for institute files upload logo,photo
async function handleFileUpload(field, file) {
  setUploading(true);
  setUploadError('');
  const formData = new FormData();
  formData.append(field, file);
  formData.append('email', form.email);
  formData.append('name', form.name); // add this

  const token = localStorage.getItem('authToken');

  try {
    const res = await fetch('/api/institute/upload-docs', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Upload failed");

    // Set the new URL in form state (so it saves with profile)
    if (data.logoUrl && field === "logo") setForm(f => ({ ...f, logoUrl: data.logoUrl }));
    if (data.coverUrl && field === "cover") setForm(f => ({ ...f, coverUrl: data.coverUrl }));
    if (data.feeStructureUrl && field === "feeStructure") setForm(f => ({ ...f, feeStructureUrl: data.feeStructureUrl }));

    setUploading(false);
    setUploadError('');
 } catch (err) {
  setUploading(false);
  setUploadError(err.message || "Upload failed. Please try again.");
}

}









 function handleSendAdminMsg() {
  if (!adminMsgText.trim()) {
    setAdminMsgSendError('Cannot send empty message.');
    setAdminMsgSendSuccess('');
    return;
  }
  const token = localStorage.getItem('authToken');
  fetch('/api/messages/institute-admin/send', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ text: adminMsgText.trim() })
  })
    .then(res => res.json())
    .then(data => {
      setAdminMsgSendError('');
      setAdminMsgSendSuccess('Message sent to admin!');
      setAdminMsgText('');
      // Refresh message thread
      fetch(`/api/messages/admin-institute/${form.email}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
        .then(res => res.json())
        .then(data => setAdminMessages(Array.isArray(data.messages) ? data.messages : []));
      setTimeout(() => {
        setShowAdminModal(false);
        setAdminMsgSendSuccess('');
      }, 1200);
    })
    .catch(() => setAdminMsgSendError('Could not send message. Try again!'));
}


function handleShowStudentProfile(app) {
  setProfileStudent(null);
  setShowProfileModal(true);
  const token = localStorage.getItem('authToken');
  fetch(`/api/student/${app.studentEmail}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
    .then(res => res.json())
    .then(data => setProfileStudent(data))
    .catch(() => setProfileStudent({ name: app.studentName, email: app.studentEmail }));
}


 function handleOpenAdminModal() {
  setShowAdminModal(true);
  setLoadingAdminMsgs(true);
  setAdminMsgError('');
  const token = localStorage.getItem('authToken');
  
  // First: Mark as read in backend
  fetch('/api/messages/mark-read', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ userType: "institute", userEmail: form.email })
  }).then(() => {
    // Then fetch the latest messages (which are now marked as read)
    fetch(`/api/messages/admin-institute/${form.email}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        setAdminMessages(Array.isArray(data.messages) ? data.messages : []);
        setLoadingAdminMsgs(false);
      })
      .catch(() => {
        setAdminMsgError('Could not load admin messages.');
        setLoadingAdminMsgs(false);
      });
  });
}



  // Profile edit handlers
  function handleProfileChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }
  function addCourseToDept(e) {
  e.preventDefault();
  const dept = departmentName.trim();
  const course = courseName.trim();
  if (!dept) {
    alert("Please add Department Name.");
    return;
  }
  if (!course) {
    alert("Please enter a Course name.");
    return;
  }
  // Add new department with this course directly to main list
  setForm(prevForm => {
    // Check if department already exists in main list:
    const existingDeptIdx = (prevForm.departments || []).findIndex(d => d.name === dept);

    if (existingDeptIdx !== -1) {
      // If department exists, add course to its courses (if not duplicate)
      const departments = [...prevForm.departments];
      if (!departments[existingDeptIdx].courses.includes(course)) {
        departments[existingDeptIdx].courses.push(course);
      }
      return { ...prevForm, departments };
    } else {
      // If department does not exist, add new department with the course
      return {
        ...prevForm,
        departments: [
          ...(prevForm.departments || []),
          { name: dept, courses: [course] }
        ]
      };
    }
  });
  // Clear inputs
  setDepartmentName('');
  setCourseName('');
  setCoursesForDept([]);
}


  function removeCourseFromDept(idx) {
    setCoursesForDept(coursesForDept.filter((_, i) => i !== idx));
  }
  function addDepartment(e) {
    e.preventDefault();
      if (departmentName) {

      setForm({
        ...form,
        departments: [
          ...(form.departments || []),
          { name: departmentName, courses: coursesForDept }
        ]
      });
      setDepartmentName('');
      setCoursesForDept([]);
    }
  }
  function removeDepartment(idx) {
    setForm({
      ...form,
      departments: (form.departments || []).filter((_, i) => i !== idx)
    });
  }
  function removeCourseFromAddedDept(deptIdx, courseIdx) {
    const updatedDepartments = [...(form.departments || [])];
    updatedDepartments[deptIdx].courses = updatedDepartments[deptIdx].courses.filter((_, i) => i !== courseIdx);
    setForm({ ...form, departments: updatedDepartments });
  }
  // Profile Save
  function handleProfileSave(e) {
  e.preventDefault();
  setMessage(''); // Clear old messages

  // Save profile to backend
  fetch('/api/institute/update', {
  method: 'POST',
  headers: { 
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
  },
  body: JSON.stringify({ email: form.email, updatedProfile: form })
})

    .then(res => res.json())
    .then(data => {
      if (data.institute) {
        setForm(data.institute); // Update state with new profile
        setMessage('Profile updated successfully!');
        setEditMode(false);
        // Optionally: clear form or close modal
      } else {
        setMessage('Could not update profile.');
      }
    })
    .catch(() => {
      setMessage('Could not connect to server.');
    });
}

  
  // Password Change
  function handleOpenPwModal() {
    setShowPwModal(true);
    setPwForm({ current: '', new: '', confirm: '' });
    setPwError('');
    setPwSuccess('');
  }
  function handleClosePwModal() {
    setShowPwModal(false);
    setPwError('');
    setPwSuccess('');
  }
  function handlePwInput(e) {
    setPwForm({ ...pwForm, [e.target.name]: e.target.value });
    setPwError('');
    setPwSuccess('');
  }
  function handlePwSubmit(e) {
  e.preventDefault();
  setPwError('');
  setPwSuccess('');

  if (!pwForm.current || !pwForm.new || !pwForm.confirm) {
    setPwError("Please fill all fields.");
    return;
  }
  if (pwForm.new.length < 4) {
    setPwError("New password must be at least 4 characters.");
    return;
  }
  if (pwForm.new !== pwForm.confirm) {
    setPwError("Passwords do not match.");
    return;
  }

  fetch('/api/institute/change-password', {
  method: 'POST',
  headers: { 
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
  },
  body: JSON.stringify({
    email: form.email,
    oldPwd: pwForm.current,
    newPwd: pwForm.new
  })
})

    .then(res => res.json())
    .then(data => {
      if (data.message && data.message.toLowerCase().includes('success')) {
        setPwSuccess("Password changed successfully.");
        setPwForm({ current: '', new: '', confirm: '' });
        setForceUpdate(f => !f);
      } else {
        setPwError(data.message || "Error changing password.");
      }
    })
    .catch(() => {
      setPwError("Could not connect to server.");
    });
}

  // Application status update
 function updateApplicationStatus(studentEmail, course, status) {
  fetch('/api/institute/applications/update-status', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('authToken')}`
    },
    body: JSON.stringify({
      studentEmail,
      course,
      status
    })
  })
    .then(res => res.json())
    .then(data => {
      if (data.message && data.message.includes('updated')) {
        setForceUpdate(f => !f); // Reload applications
        setMessage(`Status updated to "${status}"`);
      } else {
        setMessage('Error updating status. Please try again.');
      }
    })
    .catch(() => setMessage('Could not connect to server. Please try again.'));
}


 // Date Filter For Queries
function getFilteredInstQueries() {
  if (!queryDateFilter) return instQueries;
  return instQueries.filter(q => {
    if (!q.date) return false;
    const qDate = new Date(q.date);
    const filterDate = new Date(queryDateFilter + "T00:00:00");
    return (
      qDate.getFullYear() === filterDate.getFullYear() &&
      qDate.getMonth() === filterDate.getMonth() &&
      qDate.getDate() === filterDate.getDate()
    );
  });
}



const year = new Date().getFullYear();
const sessionOptions = [
  `Fall ${year}`,
  `Spring ${year}`,
  `Fall ${year - 1}`,
  `Spring ${year - 1}`,
];


 
  
// This creates a flat list of all applications for this institute, linked with each student
/*const filteredApplications = applications.filter(app => {
  const searchText = search.toLowerCase();
  let dateMatch = true;
  if (fromDate || toDate) {
    const appDate = app?.date ? new Date(app.date) : null;
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;
    if (!appDate) dateMatch = false;
    if (from && appDate < from) dateMatch = false;
    if (to) {
      const toPlus = new Date(to);
      toPlus.setDate(toPlus.getDate() + 1);
      if (appDate >= toPlus) dateMatch = false;
    }
  }
   // Session filter: Only show matching session if filter is set
  const sessionMatch = sessionFilter ? app.session === sessionFilter : true;
  return (
    (
      (app.studentName || "").toLowerCase().includes(searchText) ||
      (app.studentEmail || "").toLowerCase().includes(searchText) ||
      (app.course || "").toLowerCase().includes(searchText) ||
      ((app.status?.toLowerCase() || 'pending').includes(searchText))
    ) && dateMatch && sessionMatch
  );
});*/




  

  // AVATAR
  const initials = getInitials(form.name);
  const avatarColor = pickAvatarColor(initials);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(120deg,#dbeafe 0%,#f1f5fe 100%)"
      }}
    >
      <Container className="mt-3" style={{ maxWidth: 1200 }}>
        <Row className="justify-content-md-center">
          <Col xs={12} md={12} lg={12}>
            <Card
              className="shadow-lg dashboard-card"
              style={{
                borderRadius: 24,
                border: "none",
                marginBottom: 28,
                background: "rgba(255,255,255,0.99)",
              }}
            >
              <Card.Header as="h3" className="text-center" style={{ background: "#e0eaff", borderRadius: "24px 24px 0 0", fontWeight: 600 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 18 }}>
                  {/* Avatar */}
                  <div
                    style={{
                      width: 58,
                      height: 58,
                      borderRadius: "50%",
                      background: avatarColor,
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 28,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px #e0e6ed",
                      userSelect: "none",
                      letterSpacing: "2px"
                    }}
                  >
                    {initials}
                  </div>
                  
                  <span
  style={{
    flex: 1,
    fontSize: "2.1rem",
    fontWeight: 700,
    color: "#2d4596",
    letterSpacing: "1.1px",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    textShadow: "0 2px 8px rgba(44,70,200,0.08)",
    display: "flex",
    alignItems: "center"
  }}
>
  
  <span role="img" aria-label="institution" style={{ marginRight: 10 }}>🏫</span>
  Institute Dashboard
</span>
<div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginBottom: 24 }}>
  <Button variant="outline-danger" onClick={onLogout}>Logout</Button>
  
</div>


                  
                </div>
              </Card.Header>
              <Card.Body>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      marginBottom: 10,
    }}
  >
    {/* LEFT: Welcome */}
    <span style={{ fontSize: 22, fontWeight: 600, color: "#375" }}>
      Welcome {form.name}
    </span>
    {/* RIGHT: Profile Buttons */}
    <div
      className="profile-btn-group"
      style={{
        display: "flex",
        gap: 10,
        flexWrap: "wrap",
        justifyContent: "flex-end",
      }}
    >
      <Button
        variant="outline-primary"
        size="sm"
        style={{ borderRadius: 12, fontWeight: 500 }}
        onClick={() => setEditMode(!editMode)}
      >
        {editMode ? "Cancel" : "Edit Profile"}
      </Button>
      {!editMode && (
        <>
          <Button
            variant="outline-secondary"
            size="sm"
            style={{ borderRadius: 12, fontWeight: 500 }}
            onClick={handleOpenPwModal}
          >
            Change Password
          </Button>
          <Button
            variant={hasUnreadAdmin ? "danger" : "outline-dark"}
            size="sm"
            style={{ borderRadius: 14, fontWeight: 500 }}
            onClick={handleOpenAdminModal}
          >
            Message Admin{" "}
            {hasUnreadAdmin && (
              <Badge bg="light" text="dark">
                New
              </Badge>
            )}
          </Button>
<Button
  variant="outline-warning"
  size="sm"
  style={{ borderRadius: 14, fontWeight: 500 }}
  onClick={() => setShowQueriesModal(true)}
>
  Student Queries
</Button>


        </>
      )}
    </div>
  </div>

                <Card.Text style={{ color: "#436", fontSize: 16 }}>Manage your profile and review student applications.</Card.Text>
                {editMode ? (
                  <Form onSubmit={handleProfileSave}>
                    <Form.Group className="mb-3">
                      <Form.Label>Institute Name*</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handleProfileChange}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Email*</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleProfileChange}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Contact Person</Form.Label>
                      <Form.Control
                        type="text"
                        name="contactPerson"
                        value={form.contactPerson || ''}
                        onChange={handleProfileChange}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        type="tel"
                        name="phone"
                        value={form.phone || ''}
                        onChange={handleProfileChange}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Website</Form.Label>
                      <Form.Control
                        type="text"
                        name="website"
                        value={form.website || ''}
                        onChange={handleProfileChange}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        value={form.address || ''}
                        onChange={handleProfileChange}
                      />
                     
                     
                     
                      {/* Logo Upload */}
<Form.Group className="mb-3" style={{ display: "flex", alignItems: "center", gap: 18 }}>
  <Form.Label style={{ width: 130 }}>Institute Logo</Form.Label>
  <input
    type="file"
    accept="image/*"
    onChange={e => {
      if (e.target.files[0]) {
           console.log("Uploading for:", form.name, form.email); // add this!
        setLogoFile(e.target.files[0]);
        handleFileUpload("logo", e.target.files[0]);
      }
    }}
    disabled={uploading}
  />
  <div>
  

    {form.logoUrl ? (
      <img
        src={form.logoUrl ? API_BASE + form.logoUrl : "/default-logo.png"}
        alt="Logo"
        style={{
          width: 80,
          height: 56,
          objectFit: "cover",
          borderRadius: 10,
          border: "1px solid #ddd",
          boxShadow: "0 2px 7px rgba(30,60,80,0.07)",
          background: "#f8fafc"
        }}
      />
    ) : (
      <div style={{
        width: 56,
        height: 56,
        borderRadius: 10,
        border: "1px solid #eee",
        background: "#fafbfc",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#ccc",
        fontSize: 28
      }}>
        ?
      </div>
    )}
  </div>
</Form.Group>


{/* Cover Photo Upload */}
<Form.Group className="mb-3" style={{ display: "flex", alignItems: "center", gap: 18 }}>
  <Form.Label style={{ width: 130 }}>Cover Photo</Form.Label>
  <input
    type="file"
    accept="image/*"
    onChange={e => {
      if (e.target.files[0]) {
        setCoverFile(e.target.files[0]);
        handleFileUpload("cover", e.target.files[0]);
      }
    }}
    disabled={uploading}
  />
  <div>
 

    {form.coverUrl ? (
      <img
        src={form.coverUrl ? API_BASE + form.coverUrl : "/default-campus.jpg"}

        alt="Cover"
        style={{
          width: 120,
          height: 56,
          objectFit: "cover",
          borderRadius: 10,
          border: "1px solid #ddd",
          boxShadow: "0 2px 7px rgba(30,60,80,0.07)",
          background: "#f8fafc"
        }}
      />
    ) : (
      <div style={{
        width: 120,
        height: 56,
        borderRadius: 10,
        border: "1px solid #eee",
        background: "#fafbfc",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#ccc",
        fontSize: 22
      }}>
        No Cover
      </div>
    )}
  </div>
</Form.Group>





{/* Fee Structure Upload */}
<Form.Group className="mb-3" style={{ display: "flex", alignItems: "center", gap: 18 }}>
  <Form.Label style={{ width: 130 }}>Fee Structure (PDF or Image)</Form.Label>
  <input
    type="file"
    accept="application/pdf,image/*"
    onChange={e => {
      if (e.target.files[0]) {
        setFeeFile(e.target.files[0]);
        handleFileUpload("feeStructure", e.target.files[0]);
      }
    }}
    disabled={uploading}
  />
  <div>
   

    {form.feeStructureUrl ? (
      form.feeStructureUrl.toLowerCase().endsWith('.pdf') ? (
        <a href={form.feeStructureUrl ? API_BASE + form.feeStructureUrl : "#"}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontWeight: 600, marginLeft: 4 }}
        >View PDF</a>
      ) : (
        <img
          src={form.feeStructureUrl ? API_BASE + form.feeStructureUrl : ""}

          alt="Fee Structure"
          style={{
            width: 80,
            height: 56,
            objectFit: "cover",
            borderRadius: 8,
            border: "1px solid #ddd",
            boxShadow: "0 2px 7px rgba(30,60,80,0.07)",
            background: "#f8fafc"
          }}
        />
      )
    ) : (
      <div style={{
        width: 80,
        height: 56,
        borderRadius: 8,
        border: "1px solid #eee",
        background: "#fafbfc",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#ccc",
        fontSize: 16
      }}>
        No Fee File
      </div>
    )}
  </div>
</Form.Group>





                    </Form.Group>
                    <hr />
                    <h5 className="mt-3 mb-2">Departments & Programs</h5>
                    <Row className="mb-2">
                      <Col md={5}>
                        <Form.Control
                          placeholder="Department Name"
                          value={departmentName}
                          onChange={e => setDepartmentName(e.target.value)}
                        />
                      </Col>
                      <Col md={5}>
                        <Form.Control
                          placeholder="Add Program"
                          value={courseName}
                          onChange={e => setCourseName(e.target.value)}
                          onKeyDown={e => e.key === "Enter" ? (e.preventDefault(), addCourseToDept(e)) : null}
                        />
                      </Col>
                      <Col md={2} className="d-flex align-items-center">
                        <Button variant="success" onClick={addCourseToDept} disabled={!courseName} style={{ width: "100%", minWidth: 90 }}>
                          Add Program
                        </Button>
                      </Col>
                    </Row>
                    {/*{coursesForDept.length > 0 && (
                      <ul>
                        {coursesForDept.map((c, i) => (
                          <li key={i}>
                            {c}{" "}
                            <Button variant="link" size="sm" onClick={() => removeCourseFromDept(i)}>
                              &times;
                            </Button>
                          </li>
                        ))}
                      </ul>
                    )}*/}
                    <div style={{ marginBottom: 24, marginTop: 12 }}>
                      <Button
                        variant="primary"
                        style={{ marginRight: 10, minWidth: 145, borderRadius: 12 }}
                        onClick={addDepartment}
                        disabled={!departmentName}
                      >
                        Add Department
                      </Button>
                      
                    </div>
                {departments.length > 0 && (
  <div className="mb-4">
    <b>Departments added:</b>
    <Row>
      {departments.map((dept, deptIdx) => (
        <Col xs={12} md={6} key={deptIdx} className="mb-3">
          <div
            style={{
              border: "1.5px solid #E0E6F8",
              borderRadius: "18px",
              padding: "16px 18px",
              boxShadow: "0 2px 8px rgba(50,70,200,0.08)",
              background: "#f9fafe"
            }}
          >
            {editingDeptIdx === deptIdx ? (
              <>
                <Form.Group className="mb-2">
                  <Form.Label>Edit Department Name</Form.Label>
                  <Form.Control
                    value={editDeptName}
                    onChange={e => setEditDeptName(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-2">
                  <Form.Label>Add Program</Form.Label>
                  <Row>
                    <Col>
                      <Form.Control
                        value={editCourseName}
                        onChange={e => setEditCourseName(e.target.value)}
                        placeholder="Add New Program"
                        onKeyDown={e => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            if (
                              editCourseName.trim() &&
                              !editDeptCourses.includes(editCourseName.trim())
                            ) {
                              setEditDeptCourses([
                                ...editDeptCourses,
                                editCourseName.trim()
                              ]);
                              setEditCourseName('');
                            }
                          }
                        }}
                      />
                    </Col>
                    <Col xs="auto">
                      <Button
                        variant="success"
                        disabled={!editCourseName}
                        onClick={() => {
                          if (
                            editCourseName.trim() &&
                            !editDeptCourses.includes(editCourseName.trim())
                          ) {
                            setEditDeptCourses([
                              ...editDeptCourses,
                              editCourseName.trim()
                            ]);
                            setEditCourseName('');
                          }
                        }}
                      >
                        Add Program
                      </Button>
                    </Col>
                  </Row>
                  <div className="mt-2">
                    {editDeptCourses.map((course, cIdx) => (
                      <span
                        key={cIdx}
                        style={{
                          display: "inline-block",
                          background: "#eaf6ed",
                          color: "#187141",
                          borderRadius: "15px",
                          padding: "5px 12px",
                          marginRight: "6px",
                          marginBottom: "5px",
                          fontWeight: 500
                        }}
                      >
                        {course}
                        <Button
                          variant="link"
                          size="sm"
                          style={{ color: "#C00", marginLeft: 5, textDecoration: "none" }}
                          onClick={() => setEditDeptCourses(editDeptCourses.filter((_, i) => i !== cIdx))}
                        >
                          &times;
                        </Button>
                        
                      </span>
                    ))}
                  </div>
                </Form.Group>
                {uploading && <div style={{ color: "#176bb7", marginBottom: 10 }}>Uploading...</div>}
                {uploadError && <div style={{ color: "#c00", marginBottom: 10 }}>{uploadError}</div>}

                <Button
                  variant="primary"
                  className="me-2"
                  onClick={() => {
                    // Save changes to department
                    const updatedDepartments = [...form.departments];
                    updatedDepartments[deptIdx] = {
                      name: editDeptName,
                      courses: editDeptCourses
                    };
                    setForm({ ...form, departments: updatedDepartments });
                    setEditingDeptIdx(null);
                  }}
                >
                  Save
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => setEditingDeptIdx(null)}
                >
                  Cancel
                </Button>
              </>
            ) : (
              <>
                <div style={{ fontWeight: 700, fontSize: "1.1rem", color: "#31336e", marginBottom: "8px" }}>
                  <span role="img" aria-label="department">🏢</span> {dept.name}
                </div>
                <div style={{ marginBottom: "8px" }}>
                  {Array.isArray(dept.courses) ? dept.courses.map((course, cIdx) => (
                    <span
                      key={cIdx}
                      style={{
                        display: "inline-block",
                        background: "#eaf6ed",
                        color: "#187141",
                        borderRadius: "15px",
                        padding: "5px 12px",
                        marginRight: "6px",
                        marginBottom: "5px",
                        fontWeight: 500
                      }}
                    >
                      {course}
                    </span>
                  )):null }
                </div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="me-2"
                  onClick={() => {
                    setEditingDeptIdx(deptIdx);
                    setEditDeptName(dept.name);
                    setEditDeptCourses(dept.courses);
                    setEditCourseName('');
                  }}
                >
                  Edit
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => removeDepartment(deptIdx)}
                >
                  Remove
                </Button>
              </>
            )}
          </div>
        </Col>
      ))}
    </Row>
  </div>
)}


<Button variant="success" type="submit" className="me-2" style={{ minWidth: 110, borderRadius: 12 }}>
                        Save
                      </Button>
                      <Button variant="secondary" onClick={() => setEditMode(false)} style={{ minWidth: 110, borderRadius: 12 }}>
                        Cancel
                      </Button>


                  </Form>
                ) : (
                  <ListGroup variant="flush">
                    <ListGroup.Item><b>Name:</b> {form.name}</ListGroup.Item>
                    <ListGroup.Item><b>Email:</b> {form.email}</ListGroup.Item>
                    {form.contactPerson && <ListGroup.Item><b>Contact Person:</b> {form.contactPerson}</ListGroup.Item>}
                    {form.phone && <ListGroup.Item><b>Phone:</b> {form.phone}</ListGroup.Item>}
                    {form.website && <ListGroup.Item><b>Website:</b> {form.website}</ListGroup.Item>}
                    {form.address && <ListGroup.Item><b>Address:</b> {form.address}</ListGroup.Item>}
                    <ListGroup.Item>
  <b>Departments & Programs</b>
  {form.departments && form.departments.length > 0 ? (
    <Row className="mb-0 mt-1">
      {form.departments.map((dept, idx) => (
        <Col xs={12} md={6} key={idx} className="mb-2">
          <div
            style={{
              border: "1.2px solid #e0eaff",
              borderRadius: "14px",
              background: "#f5f8fd",
              padding: "10px 16px"
            }}
          >
            <div style={{ fontWeight: 600, fontSize: "1rem", color: "#314687", marginBottom: 4 }}>
              <span role="img" aria-label="department">🏢</span> {dept.name}
            </div>
            <div>
              {Array.isArray(dept.courses) ? dept.courses.map((c, i) => (
                <span
                  key={i}
                  style={{
                    display: "inline-block",
                    background: "#eaf6ed",
                    color: "#187141",
                    borderRadius: "13px",
                    padding: "4px 10px",
                    marginRight: "6px",
                    marginBottom: "5px",
                    fontWeight: 500,
                    fontSize: "0.97em"
                  }}
                >
                  {c}
                </span>
              )): null}
            </div>
          </div>
        </Col>
      ))}
    </Row>
  ) : (
    <span className="text-muted"> No departments listed.</span>
  )}
</ListGroup.Item>

                  </ListGroup>
                )}
                {message && <Alert variant="success" className="mt-3 text-center">{message}</Alert>}
              </Card.Body>
            </Card>

            {/* --- Applicants Table with Search --- */}
            <Card className="shadow" style={{ borderRadius: 24, marginBottom: 30, background: "rgba(248,250,252,0.96)" }}>
              <Card.Header as="h5" style={{ background: "#eff6ff", borderRadius: "24px 24px 0 0", fontWeight: 500 }}>
                <span
  style={{
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#2d4596",      // A rich blue (change if you want)
    letterSpacing: "1px",
    fontFamily: "'Segoe UI', Arial, sans-serif"
  }}
>
  Applications
</span>
               

                {/* Date filter block starts here */}
{/* Date + Session filters (edit without fetching) */}
<div
  style={{
    display: "flex",
    flexWrap: "wrap",
    gap: 12,
    alignItems: "end",
    marginTop: 10,
    rowGap: 0,
  }}
>
  <div style={{ display: "flex", alignItems: "end", flexShrink: 0 }}></div>
  <InputGroup style={{ maxWidth: 350, height: 35 }}>
  <Form.Control
    type="text"
    style={{ maxWidth: 350, height: 35 }}
    placeholder="Search by Name, Email, Program..."
    value={searchInput}
    onChange={e => setSearchInput(e.target.value)}
    onKeyDown={e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        setSearch(searchInput);
        setPage(1);
      }
    }}
  />
  <Button
    variant="primary"
    style={{ maxWidth: 350, height: 35 }}
    onClick={() => {
      setSearch(searchInput);
      setPage(1);
    }}
  >
    Search
  </Button>
</InputGroup>
  {/* Date range */}
  <div style={{ display: "flex", alignItems: "end", gap: 0, height: 30 }}>
    <Form.Label style={{ marginBottom: 7, fontSize: "1.10rem", minWidth: 95 }}>
      Date Filter:
    </Form.Label>

    <Form.Control
      type="date"
      size="sm"
      style={{ width: 130, minWidth: 120, height: 35 }}
      value={fromDateInput}
      onChange={e => setFromDateInput(e.target.value)}
      placeholder="From"
      inputMode="none"
      onKeyDown={e => {
        const allowed = ['Tab','Shift','ArrowLeft','ArrowRight','Home','End','Escape'];
        if (allowed.includes(e.key)) return;
        if (e.key.length === 1) e.preventDefault();
      }}
      onPaste={e => e.preventDefault()}
      onDrop={e => e.preventDefault()}
    />

    <span style={{ marginBottom: 7, margin: "0 4px" }}>To</span>

    <Form.Control
      type="date"
      size="sm"
      style={{ width: 130, minWidth: 120, height: 35 }}
      value={toDateInput}
      onChange={e => setToDateInput(e.target.value)}
      placeholder="To"
      inputMode="none"
      onKeyDown={e => {
        const allowed = ['Tab','Shift','ArrowLeft','ArrowRight','Home','End','Escape'];
        if (allowed.includes(e.key)) return;
        if (e.key.length === 1) e.preventDefault();
      }}
      onPaste={e => e.preventDefault()}
      onDrop={e => e.preventDefault()}
    />

    <Button
      size="sm"
      variant="outline-secondary"
      style={{ marginLeft: 6, minWidth: 40 }}
      onClick={() => {
        setFromDateInput('');
        setToDateInput('');
      }}
      disabled={!fromDateInput && !toDateInput}
    >
      Clear
    </Button>
  </div>

  {/* Session dropdown */}
  <div style={{ display: "flex", alignItems: "end", gap: 6, minWidth: 200 }}>
    <span style={{ fontSize: "0.80em", fontWeight: 500, minWidth: 55, marginBottom: 7, height: 20 }}>
      Session
    </span>
    <Form.Select
      size="sm"
      value={sessionFilterInput}
      onChange={e => setSessionFilterInput(e.target.value)}
      style={{ minWidth: 110, maxWidth: 150, height: 35 }}
    >
      <option value="">All Sessions</option>
      {sessionOptions.map(option => (
        <option value={option} key={option}>{option}</option>
      ))}
    </Form.Select>
  </div>

  {/* Apply button */}
  <div style={{ display: "flex", alignItems: "end", height: 30 }}>
    <Button
      size="sm"
      variant="primary"
      onClick={() => {
        // Copy the "draft" values into the real filters,
        // then reset to page 1 so backend refetches once.
        setFromDate(fromDateInput || '');
        setToDate(toDateInput || '');
        setSessionFilter(sessionFilterInput || '');
        setPage(1);
      }}
      style={{ minWidth: 90 }}
    >
      Apply
    </Button>
  </div>
</div>
  
  {/* Date filter block ends here */}



              </Card.Header>
              <Card.Body>
                <div className="dashboard-table-responsive">
              
                <Table striped bordered hover responsive className="dashboard-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Session</th>
                      <th>Applied Program</th>
                      
                      <th>Status</th>
                      <th>Action</th>
                      <th>Profile</th>
                      <th>Messages</th>
                      <th>Forms</th>
                      
                    </tr>
                  </thead>
                  <tbody>
  {Array.isArray(applications) ? applications.map((app, idx) => {
    const status = app?.status || "pending";
    const hasNewMsg = Array.isArray(app?.messages)
      ? app.messages.some(m => m && m.from === "student" && !m.read)
      : false;
    return (
      <tr key={(app?.studentEmail || "noemail") + '-' + (app?.course || "nocourse") + '-' + idx}>
        <td>{app?.studentName || '-'}</td>
        <td>{status === "approved" ? app?.studentEmail || '-' : "*****"}</td>
        {/*<td>{status === "approved" ? app?.studentPhone || '-' : "*****"}</td>*/}
        <td>{app?.session || '-'}</td>
        <td>{app?.course || '-'}</td>
        <td style={{ textTransform: "capitalize" }}>{status}</td>
        <td>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {status === "pending" && (
              <>
                <Button
                  variant="outline-success"
                  size="sm"
                  style={{ minWidth: 90, borderRadius: 8, marginBottom: 4 }}
                  onClick={() => updateApplicationStatus(app?.studentEmail, app?.course, "approved")}
                >
                  Approve
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  style={{ minWidth: 90, borderRadius: 8 }}
                  onClick={() => updateApplicationStatus(app?.studentEmail, app?.course, "rejected")}
                >
                  Reject
                </Button>
              </>
            )}
            {(status === "approved" || status === "rejected") && (
              <span className="text-muted" style={{ fontSize: 13 }}>
                Decision made. Contact admin to change.
              </span>
            )}
          </div>
        </td>
        <td>
          <Button
            size="sm"
            variant="secondary"
            style={{ borderRadius: 8 }}
            onClick={() => handleShowStudentProfile(app)}     
            disabled={status !== "approved"}
            title={status !== "approved" ? "Only available for approved applications" : ""}
          >
            Profile
          </Button>
        </td>
        <td>
          <Button
            size="sm"
            variant="info"
            style={{ borderRadius: 8 }}
            onClick={() => handleOpenAppMsgModal(app, app.studentEmail)}
            disabled={status !== "approved"}
            title={status !== "approved" ? "Only available for approved applications" : ""}
          >
            Messages
            {Array.isArray(app?.messages) && app.messages.some(m => m.from === "student" && !m.read) && (
              <Badge bg="danger" className="ms-1">New</Badge>
            )}
          </Button>
        </td>
        <td>
          <Button
            size="sm"
            variant="primary"
            style={{ borderRadius: 8, marginTop: 6 }}
            disabled={status === "rejected"}
            title={status === "rejected" ? "Cannot download rejected application" : ""}
            onClick={() => handleDownloadApplicationForm({ email: app.studentEmail, name: app.studentName }, app.course)}
          >
            Admission Form
          </Button>
        </td>
      </tr>
    );
  }) : null}
</tbody>


                </Table>
                <div style={{ display:'flex', justifyContent:'center', marginTop:10 }}>
  {hasMore ? (
    <Button
      variant="outline-primary"
      size="sm"
      disabled={loadingMore}
      onClick={() => setPage(p => p + 1)}
    >
      {loadingMore ? 'Loading…' : 'Load more'}
    </Button>
  ) : (
    applications.length > 0 && <div className="text-muted">No more applications.</div>
  )}
</div>

                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

       


        {/* Modal for changing password */}
        <Modal show={showPwModal} onHide={handleClosePwModal}>
          <Modal.Header closeButton>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handlePwSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Current Password</Form.Label>
                <Form.Control
                  type="password"
                  name="current"
                  value={pwForm.current}
                  onChange={handlePwInput}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  name="new"
                  value={pwForm.new}
                  onChange={handlePwInput}
                  required
                  minLength={4}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Confirm New Password</Form.Label>
                <Form.Control
                  type="password"
                  name="confirm"
                  value={pwForm.confirm}
                  onChange={handlePwInput}
                  required
                  minLength={4}
                />
              </Form.Group>
              {pwError && <Alert variant="danger">{pwError}</Alert>}
              {pwSuccess && <Alert variant="success">{pwSuccess}</Alert>}
              <Button variant="secondary" onClick={handleClosePwModal}>
                Cancel
              </Button>
              <Button variant="primary" type="submit" className="ms-2">
                Change Password
              </Button>
            </Form>
          </Modal.Body>
        </Modal>

        {/* Modal for admin messaging */}
        <Modal show={showAdminModal} onHide={() => setShowAdminModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Messages with Admin</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: 400, overflowY: 'auto' }}>
            {loadingAdminMsgs ? (
  <div className="text-muted px-3 py-2">Loading messages...</div>
) : adminMsgs.length === 0 ? (
  <div className="text-muted">No messages yet.</div>
) : (
  <ListGroup variant="flush" style={{ maxHeight: 280, overflowY: 'auto', borderRadius: 8 }}>
    {adminMsgs.map((m, i) => (
      <ListGroup.Item key={i}>
        <b>{m.from === "admin" ? "Admin" : form.name}</b>: {m.text}
        <div className="text-secondary small">{m.date && (new Date(m.date)).toLocaleString()}</div>
      </ListGroup.Item>
    ))}
  </ListGroup>
)}

            <Form.Group className="mt-3">
              <Form.Control
                as="textarea"
                rows={2}
                value={adminMsgText}
                placeholder="Type your message to admin..."
                onChange={e => setAdminMsgText(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAdminModal(false)}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={handleSendAdminMsg}
              disabled={!adminMsgText.trim()}
            >
              Send
            </Button>
          </Modal.Footer>
        </Modal>
        
        {/* --- Application Messages Modal --- */}
<Modal show={showAppMsgModal} onHide={() => setShowAppMsgModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>
      Messages for {activeAppMsg?.course || "Application"}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ maxHeight: 400, overflowY: 'auto' }}>
    {appMsgLoading ? (
      <div className="text-muted px-3 py-2">Loading messages...</div>
    ) : appMsgThread.length === 0 ? (
      <div className="text-muted">No messages yet.</div>
    ) : (
      <ListGroup variant="flush" style={{ maxHeight: 280, overflowY: 'auto', borderRadius: 8 }}>
        {appMsgThread.map((msg, idx) => (
          <ListGroup.Item key={idx}>
            <div>
              <b style={{ color: msg.from === "institute" ? "#2d4596" : "#10804f" }}>
                {msg.from === "institute" ? "You" : "Student"}
              </b>: {msg.text}
            </div>
            <div className="text-muted small">{msg.date && (new Date(msg.date)).toLocaleString()}</div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    )}

    <Form.Group className="mt-3">
      <Form.Control
        as="textarea"
        rows={2}
        value={appMsgText}
        placeholder="Type your reply..."
        onChange={e => setAppMsgText(e.target.value)}
        disabled={appMsgLoading}
      />
    </Form.Group>
    {appMsgError && <div className="text-danger mt-2">{appMsgError}</div>}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowAppMsgModal(false)}>
      Close
    </Button>
    <Button
      variant="primary"
      onClick={handleSendAppMsg}
      disabled={!appMsgText.trim() || appMsgLoading}
    >
      Send
    </Button>
  </Modal.Footer>
</Modal>

        
        
        
        {/* Modal for student profile viewing */}
<Modal show={showProfileModal} onHide={() => setShowProfileModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>
      {profileStudent ? `${profileStudent.name}'s Profile` : 'Student Profile'}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body className="print-profile-modal">
    {profileStudent ? (
      <div>
        <div
  style={{
    background: "#eff6ff",
    borderRadius: 16,
    padding: "20px",
    marginBottom: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
  }}
>
  <Row className="mb-3">
    <Col md={6}>
      <div style={{ fontSize: "1rem", fontWeight: 600, color: "#1d3557" }}>👤 Name</div>
      <div style={{ fontSize: "1.1rem" }}>{profileStudent.name}</div>
    </Col>
    <Col md={6}>
      <div style={{ fontSize: "1rem", fontWeight: 600, color: "#1d3557" }}>📧 Email</div>
      <div style={{ fontSize: "1.1rem" }}>{profileStudent.email}</div>
    </Col>
  </Row>
  <Row className="mb-3">
    <Col md={6}>
      <div style={{ fontSize: "1rem", fontWeight: 600, color: "#1d3557" }}>📱 Phone</div>
      <div style={{ fontSize: "1.1rem" }}>{profileStudent.phone || <span className="text-muted">N/A</span>}</div>
    </Col>
    <Col md={6}>
      <div style={{ fontSize: "1rem", fontWeight: 600, color: "#1d3557" }}>🎂 Date of Birth</div>
      <div style={{ fontSize: "1.1rem" }}>{profileStudent.dob || <span className="text-muted">N/A</span>}</div>
    </Col>
  </Row>
  <Row className="mb-3">
    <Col md={6}>
      <div style={{ fontSize: "1rem", fontWeight: 600, color: "#1d3557" }}>🏠 Address</div>
      <div style={{ fontSize: "1.1rem" }}>{profileStudent.address || <span className="text-muted">N/A</span>}</div>
    </Col>
    <Col md={6}>
      <div style={{ fontSize: "1rem", fontWeight: 600, color: "#1d3557" }}>⚧ Gender</div>
      <div style={{ fontSize: "1.1rem" }}>{profileStudent.gender || <span className="text-muted">N/A</span>}</div>
    </Col>
  </Row>
  <Row>
    <Col md={6}>
      <div style={{ fontSize: "1rem", fontWeight: 600, color: "#1d3557" }}>🌍 Nationality</div>
      <div style={{ fontSize: "1.1rem" }}>{profileStudent.nationality || <span className="text-muted">N/A</span>}</div>
    </Col>
    
  </Row>
</div>



        <hr />
        <b>Documents:</b>
        <div>
          {Array.isArray(profileStudent?.documents) && profileStudent.documents.length > 0 ? (
  <Row>
    {profileStudent.documents
  .filter(
    doc =>
      !["receipt", "paymentreceipt", "challan"].includes(
        (doc.typeTag || doc.name || "").toLowerCase()
      )
  )
  .map((doc, i) => {
      const isImage = doc.name.match(/\.(jpg|jpeg|png|gif)$/i);
      const isPdf = doc.name.match(/\.pdf$/i);

      return (
        <Col md={6} key={i} className="mb-3">
          <div style={{ position: "relative" }}>
            <li key={i} style={{ marginBottom: 16, position: "relative" }}>
  <a
    href={getDocDownloadUrl(doc)}
    download={doc.name}
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: "none", fontWeight: 600 }}
    onMouseEnter={() => setHoveredDocIndex(i)}
    onMouseLeave={() => setHoveredDocIndex(null)}
  >
    {doc.name}
  </a>
  {/* Preview only on hover */}
  {hoveredDocIndex === i && (
    <div
      style={{
        position: "absolute",
        left: 160,
        top: 0,
        zIndex: 10,
        background: "#fff",
        border: "1px solid #eee",
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
        padding: 8,
        minWidth: 120,
        minHeight: 120,
        maxWidth: 200,
        maxHeight: 200,
      }}
    >
      {doc.type && doc.type.startsWith("image/") ? (
        <img
          src={getDocDownloadUrl(doc)}
          alt="Preview"
          style={{ width: "100%", maxHeight: 180, borderRadius: 6 }}
        />
      ) : doc.type === "application/pdf" ? (
        <embed
          src={getDocDownloadUrl(doc)}
          type="application/pdf"
          width="180px"
          height="180px"
          style={{ borderRadius: 6 }}
        />
      ) : (
        <span className="text-muted">No preview available</span>
      )}
    </div>
  )}
</li>

            <div
              id={`preview-${i}`}
              style={{
                display: "none",
                position: "absolute",
                top: "30px",
                left: "0",
                zIndex: 10,
                border: "1px solid #ccc",
                borderRadius: "8px",
                background: "#fff",
                padding: "5px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                maxWidth: "300px",
                maxHeight: "200px",
                overflow: "auto"
              }}
            >
              {isImage ? (
               <img
  src={doc.url ? API_BASE + doc.url : doc.data}
  alt="Preview"
  style={{ width: "100%", borderRadius: "6px" }}
/>
) : isPdf ? (
<embed
  src={doc.url ? API_BASE + doc.url : doc.data}
  type="application/pdf"
  width="100%"
  height="200px"
/>


              ) : (
                <div className="text-muted">Preview not available</div>
              )}
            </div>
          </div>
        </Col>
      );
    })}
  </Row>
) : (
  <span className="text-muted">No documents uploaded.</span>
)}
        </div>
        <hr />      
     </div>
    ) : (
      <div className="text-muted">Loading Please Wait</div>
    )}
    
  </Modal.Body>
  <Modal.Footer>
 
  <Button variant="secondary" onClick={() => setShowProfileModal(false)}>
    Close
  </Button>
</Modal.Footer>

</Modal>
<div
  id="application-form-preview"
  style={{
    display: "none",
    padding: 32,
    background: "#fff",
    color: "#222",
    width: 700,
    margin: "0 auto",
    fontFamily: "sans-serif",
    borderRadius: 12,
    boxShadow: "0 2px 12px #bbb"
  }}
>
  {applicationFormToPreview ? (
    <>
      <h2 style={{ textAlign: "center", marginBottom: 24 }}>Student Application Form</h2>
      {/* Photo */}
      {applicationFormToPreview.photo && (
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}>
          <img
            src={applicationFormToPreview.photo}
            alt="Photograph"
            style={{
              width: 120,
              height: 120,
              objectFit: "cover",
              borderRadius: 12,
              border: "2px solid #888"
            }}
          />
        </div>
      )}

      {/* Personal Info Table */}
      <table style={{ width: "100%", marginBottom: 20 }}>
        <tbody>
          <tr>
            <td><b>Program Applied For:</b></td>
            <td>{applicationFormToPreview.program}</td>
            <td><b>Alternative Program:</b></td>
            <td>{applicationFormToPreview.altProgram}</td>
          </tr>
          <tr>
            <td><b>Roll No:</b></td>
            <td>{applicationFormToPreview.rollNo}</td>
            <td><b>Name:</b></td>
            <td>{applicationFormToPreview.name}</td>
          </tr>
          <tr>
            <td><b>Father's Name:</b></td>
            <td>{applicationFormToPreview.fatherName}</td>
            <td><b>Student CNIC:</b></td>
            <td>{applicationFormToPreview.cnic}</td>
          </tr>
          <tr>
            <td><b>Date of Birth:</b></td>
            <td>{applicationFormToPreview.dob}</td>
            <td><b>Gender:</b></td>
            <td>{applicationFormToPreview.gender}</td>
          </tr>
          <tr>
            <td><b>Present Address:</b></td>
            <td>{applicationFormToPreview.presentAddress}</td>
            <td><b>Permanent Address:</b></td>
            <td>{applicationFormToPreview.permanentAddress}</td>
          </tr>
          <tr>
            <td><b>Domicile:</b></td>
            <td>{applicationFormToPreview.domicile}</td>
            <td><b>Locality:</b></td>
            <td>{applicationFormToPreview.locality}</td>
          </tr>
          <tr>
            <td><b>Nationality:</b></td>
            <td>{applicationFormToPreview.nationality}</td>
            <td><b>Marital Status:</b></td>
            <td>{applicationFormToPreview.maritalStatus}</td>
          </tr>
          <tr>
            <td><b>Identification Mark:</b></td>
            <td>{applicationFormToPreview.identificationMark}</td>
            <td><b>Religion:</b></td>
            <td>{applicationFormToPreview.religion}</td>
          </tr>
          <tr>
            <td><b>Blood Group:</b></td>
            <td>{applicationFormToPreview.bloodGroup}</td>
            <td><b>Email ID:</b></td>
            <td>{applicationFormToPreview.email}</td>
          </tr>
          <tr>
            <td><b>Guardian Cell No:</b></td>
            <td>{applicationFormToPreview.guardianCell}</td>
            <td><b>Cell No:</b></td>
            <td>{applicationFormToPreview.cell}</td>
          </tr>
        </tbody>
      </table>

      {/* Academic Table */}
      <h4>Academic Qualifications</h4>
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
        <thead>
          <tr>
            <th style={{border: "1px solid #bbb", padding: 4}}>Qualification</th>
            <th style={{border: "1px solid #bbb", padding: 4}}>Passing Year</th>
            <th style={{border: "1px solid #bbb", padding: 4}}>Roll No</th>
            <th style={{border: "1px solid #bbb", padding: 4}}>Total Marks</th>
            <th style={{border: "1px solid #bbb", padding: 4}}>Obtained Marks</th>
            <th style={{border: "1px solid #bbb", padding: 4}}>%</th>
            <th style={{border: "1px solid #bbb", padding: 4}}>Board/University</th>
            <th style={{border: "1px solid #bbb", padding: 4}}>Reg No</th>
            <th style={{border: "1px solid #bbb", padding: 4}}>Examination</th>
          </tr>
        </thead>
        <tbody>
          {(applicationFormToPreview.academicRecords || []).map((row, idx) => (
            <tr key={idx}>
              <td style={{border: "1px solid #bbb", padding: 4}}>{row.qualification}</td>
              <td style={{border: "1px solid #bbb", padding: 4}}>{row.passingYear}</td>
              <td style={{border: "1px solid #bbb", padding: 4}}>{row.rollNo}</td>
              <td style={{border: "1px solid #bbb", padding: 4}}>{row.totalMarks}</td>
              <td style={{border: "1px solid #bbb", padding: 4}}>{row.obtainedMarks}</td>
              <td style={{border: "1px solid #bbb", padding: 4}}>{row.percentage}</td>
              <td style={{border: "1px solid #bbb", padding: 4}}>{row.board}</td>
              <td style={{border: "1px solid #bbb", padding: 4}}>{row.registrationNo}</td>
              <td style={{border: "1px solid #bbb", padding: 4}}>{row.examination}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Document Checklist */}
      <h4>Document Checklist</h4>
      <ul>
        <li>
          <b>Matriculation Certificate:</b> {applicationFormToPreview.documentChecklist?.matriculation ? "✔️" : "❌"}
        </li>
        <li>
          <b>Intermediate Certificate:</b> {applicationFormToPreview.documentChecklist?.intermediate ? "✔️" : "❌"}
        </li>
        <li>
          <b>Graduation Certificate:</b> {applicationFormToPreview.documentChecklist?.graduation ? "✔️" : "❌"}
        </li>
        <li>
          <b>Photographs:</b> {applicationFormToPreview.documentChecklist?.photographs ? "✔️" : "❌"}
        </li>
        <li>
          <b>CNIC (Student):</b> {applicationFormToPreview.documentChecklist?.cnicStudent ? "✔️" : "❌"}
        </li>
        <li>
          <b>CNIC (Father):</b> {applicationFormToPreview.documentChecklist?.cnicFather ? "✔️" : "❌"}
        </li>
        <li>
          <b>Domicile:</b> {applicationFormToPreview.documentChecklist?.domicile ? "✔️" : "❌"}
        </li>
      </ul>
      <p style={{ fontStyle: "italic", color: "#17a2b8" }}>
        Please upload these documents in your profile.
      </p>

      {/* Declaration */}
      <h4>Declaration</h4>
      <p>
        I hereby declare that all the information provided above is true and correct to the best of my knowledge. I understand that any false information may result in cancellation of my application.
      </p>
      <b>
        Agreed: {applicationFormToPreview.declarationAgreed ? "✔️" : "❌"}
      </b>
    </>
  ) : (
    <div style={{ textAlign: "center", color: "#888" }}>No form to display.</div>
  )}

<Modal show={showQueriesModal} onHide={() => setShowQueriesModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Student Queries</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form.Group controlId="queryDateFilter" className="mb-2" style={{ maxWidth: 220 }}>
  <Form.Label style={{ marginBottom: 2 }}>Filter by Date</Form.Label>
  <Form.Control
    type="date"
    value={queryDateFilter}
    onChange={e => setQueryDateFilter(e.target.value)}
  />
</Form.Group>

    {queriesLoading && <div>Loading queries...</div>}
    {queriesError && <Alert variant="danger">{queriesError}</Alert>}
    {!queriesLoading && instQueries.length === 0 && (
        <div className="text-muted">
    {queryDateFilter
      ? "No queries found for selected date."
      : "No queries received yet."
    }
  </div>
    )}
    {!queriesLoading && instQueries.length > 0 && (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Student Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Course</th>
            <th>Date</th>
            <th>Open</th>
          </tr>
        </thead>
        <tbody>
          {getFilteredInstQueries().map((q, idx) => (
            <tr key={q._id}>
              <td>{q.studentName}</td>
              <td>{q.studentPhone}</td>
              <td>{q.studentEmail}</td>
              <td>{q.courseName}</td>
              <td>{new Date(q.date).toLocaleString()}</td>
              <td>
                <Button
  size="sm"
  onClick={() => {
    setSelectedQuery(q);
    if (!readQueryIds.includes(q._id)) {
      setReadQueryIds(prev => [...prev, q._id]);
    }
  }}
  variant={readQueryIds.includes(q._id) ? "secondary" : "info"}
>
  View
 
</Button>

              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )}
    {/* Query Detail View */}
    {selectedQuery && (
      <div style={{ marginTop: 20, border: "1px solid #eee", borderRadius: 8, padding: 16 }}>
        <h5>Query Details</h5>
        <p><b>Student Name:</b> {selectedQuery.studentName}</p>
        <p><b>Phone:</b> {selectedQuery.studentPhone}</p>
        <p><b>Email:</b> {selectedQuery.studentEmail}</p>
        <p><b>Course:</b> {selectedQuery.courseName}</p>
        <p><b>Message:</b> {selectedQuery.message || <span className="text-muted">(none)</span>}</p>
        <p><b>Date:</b> {new Date(selectedQuery.date).toLocaleString()}</p>
        <Button variant="secondary" onClick={() => setSelectedQuery(null)}>Close</Button>
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowQueriesModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>


</div>


      </Container>
    </div>
  );
}

export default InstituteDashboard;
